import { tokens } from "styles/Tokens";

interface Props {
  color: string;
  disabled?: boolean;
}

function MultiCard(props: Props) {
  const { color, disabled } = props;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        className="icon-svg"
        d="M13.5 2.5H7.5C6.94772 2.5 6.5 2.94772 6.5 3.5V7.5C6.5 8.05228 6.94772 8.5 7.5 8.5H13.5C14.0523 8.5 14.5 8.05228 14.5 7.5V3.5C14.5 2.94772 14.0523 2.5 13.5 2.5Z"
        stroke={disabled ? tokens.Text.General.Tertiary : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="icon-svg"
        d="M12 11H5C4.73478 11 4.48043 10.8946 4.29289 10.7071C4.10536 10.5196 4 10.2652 4 10V5"
        stroke={disabled ? tokens.Text.General.Tertiary : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="icon-svg"
        d="M10 13.5H2.5C2.23478 13.5 1.98043 13.3946 1.79289 13.2071C1.60536 13.0196 1.5 12.7652 1.5 12.5V7"
        stroke={disabled ? tokens.Text.General.Tertiary : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MultiCard;
